import { Box, H1 } from '@betterment/samba-react';
import { ErrorBoundary } from '@sentry/react';
import { useLoaderData, useSearchParams } from 'react-router-dom';

import { EditAddressForm, type EditAddressFormProps } from './EditAddressForm';

import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { WorkflowLayout } from '../Shared/layout/WorkflowLayout';
import { locationAssign } from '../Shared/path-helpers';
import { urlBuilder } from '../Shared/urlBuilder';

export type EditAddressPageLoaderData = EditAddressFormProps;

const EditAddressPage = () => {
  const { hasPendingIraWithdrawals, isMaybeCheckingUser } = useLoaderData<EditAddressPageLoaderData>();

  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('return_to');

  const exitLocation = returnTo !== null ? returnTo : urlBuilder.appProfile.absolute();

  return (
    <ErrorBoundary>
      <IdempotencyProviderWithFeatureRegistry featureName="settings">
        <WorkflowLayout
          feature="edit address"
          pageTitle="Personal Information"
          workflowTitle=""
          onClose={() => locationAssign(exitLocation)}
          size="full"
        >
          <Box
            css={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: 'space.500',
              smDown: {
                gridTemplateColumns: '1fr',
              },
            }}
          >
            <H1 variant="pageTitle">{isMaybeCheckingUser ? 'Update your addresses' : 'Update your address'}</H1>
            <EditAddressForm
              hasPendingIraWithdrawals={hasPendingIraWithdrawals}
              isMaybeCheckingUser={isMaybeCheckingUser}
              onCloseUrl={exitLocation}
            />
          </Box>
        </WorkflowLayout>
      </IdempotencyProviderWithFeatureRegistry>
    </ErrorBoundary>
  );
};

export default EditAddressPage;
